import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableContainer, Paper } from '@mui/material';
import FinancialProductWarrantiesTableHead from './FinancialProductWarrantiesTableHead';
import FinancialProductWarrantiesTableBody from './FinancialProductWarrantiesTableBody';
import PropTypes from 'prop-types';
import Placeholder from 'components/common/Placeholder';

const FinancialProductWarrantiesTable = ({ canWrite, warranties, onAdd, onEdit, onDelete, isSaved }) => {
  const [t] = useTranslation();

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <FinancialProductWarrantiesTableHead canWrite={canWrite} isSaved={isSaved} onAdd={onAdd} />
          {isSaved && <FinancialProductWarrantiesTableBody canWrite={canWrite} warranties={warranties} onEdit={onEdit} onDelete={onDelete} />}
        </Table>
      </TableContainer>
      {isSaved && warranties?.length === 0 && <Placeholder message={t('TableIsEmpty')} color={'gray'} />}
    </>
  );
};

FinancialProductWarrantiesTable.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  warranties: PropTypes.array.isRequired,
  onAdd: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  isSaved: PropTypes.bool.isRequired
};

export default FinancialProductWarrantiesTable;
